// jQuery(document).ready(function ($) {

//     $('.custom-submit-btn').on('click', function (e) {
//         e.preventDefault();

//         var $form = $('.onst-custom-form');

//         $form.css({
//             'display': 'block',
//             'visibility': 'hidden',
//             'position': 'absolute',
//             'left': '-9999px'
//         });

//         $form.find('input[name="Name"]').val('John Smith');
//         $form.find('input[name="contact[email]"]').val('john@example.com');
//         $form.find('input[name="Company"]').val('ABC Company');
//         $form.find('input[name="Phone"]').val('+61 400 123 456');
//         $form.find('textarea[name="Comment"]').val('This is a test message.');

//         $form.find('.onst-custom-form-submit').click();
//     });

// });

document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('quotePopup');

    // Open popup
    document.querySelectorAll('.get-quote').forEach(button => {
        button.addEventListener('click', function () {

            const source = this.dataset.source;
            // Set hidden field value
            document.getElementById('datasource').value = source;

            popup.classList.add('active');
            document.body.style.overflow = 'hidden';
        });
    });

    // Close popup via close icon
    popup.querySelector('.popup-close').addEventListener('click', function () {
        popup.classList.remove('active');
        document.body.style.overflow = '';
    });

    // Close popup when clicking overlay
    popup.addEventListener('click', function (e) {
        if (e.target === popup) {
            popup.classList.remove('active');
            document.body.style.overflow = '';
        }
    });

    // Close popup on ESC key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            popup.classList.remove('active');
            document.body.style.overflow = '';
        }
    });
});

// Push Data into hubspot
jQuery(document).ready(function ($) {

    /**
     * ----------------------------
     * TRACKING FUNCTIONS
     * ----------------------------
     */

    function getParam(name) {
        const url = new URL(window.location.href);
        return url.searchParams.get(name);
    }

    function getStoredValue(name) {
        return sessionStorage.getItem(name) || '';
    }

    /**
     * ----------------------------
     * SAVE URL PARAMS
     * ----------------------------
     */

    function storeTrackingParams() {

        let hasUTM = false;

        ['utm_source', 'utm_medium', 'utm_campaign']
        .forEach(function(param) {

            const value = getParam(param);

            if (value) {
                hasUTM = true;
                sessionStorage.setItem(param, value);
            }
        });

       if (hasUTM) {
            sessionStorage.setItem('gclid_and_gtm', window.location.href);
        }
    }

    /**
     * ----------------------------
     * BUILD HUBSPOT FIELDS
     * ----------------------------
     */

    function getHubspotFields() {

        const fullName = $('#name').val().trim();
        const nameParts = fullName.split(/\s+/);
        const firstName = nameParts[0] || '';
        const lastName = nameParts.slice(1).join(' ') || '';

        return [
            {
                name: "firstname",
                value: firstName
            },
            {
                name: "lastname",
                value: lastName
            },
            {
                name: "company",
                value: $('#company').val().trim()
            },
            {
                name: "email",
                value: $('#email').val().trim()
            },
            {
                name: "phone",
                value: $('#phone').val().trim()
            },
            {
                name: "message",
                value: $('#message').val().trim()
            },
            {
                name: "source",
                value: $('#datasource').val().trim()
            },
            {
                name: "utm_source",
                value: getStoredValue('utm_source')
            },
            {
                name: "utm_medium",
                value: getStoredValue('utm_medium')
            },
            {
                name: "utm_campaign",
                value: getStoredValue('utm_campaign')
            },
            {
                name: "gclid_and_gtm",
                value: getStoredValue('gclid_and_gtm')
            },
            {
                name: "page_url",
                value: window.location.href.split('?')[0]
            },
            {
    name: "marketing_optin",
    value: $('#marketing_opt_in').is(':checked') ? "true" : "false"
}
        ];
    }

    /**
     * ----------------------------
     * HUBSPOT AJAX
     * ----------------------------
     */

    function getField(fields, name) {
        const item = fields.find(field => field.name === name);
        return item ? item.value : '';
    }

    function submitToHubSpot() {

        const fields = getHubspotFields();

        // Store GCLID
        const fullUrl = getStoredValue('gclid_and_gtm');
        let gclid = '';

        if (fullUrl) {
            try {
                gclid = new URL(fullUrl).searchParams.get('gclid') || '';
            } catch (e) {
                console.log('Invalid URL stored');
            }
        }

        fields.push({
            name: "gcl_id",
            value: gclid
        });

        console.log('HubSpot Fields:', fields);

        $('.hcf-submit-btn')
            .prop('disabled', true)
            .text('Sending...');

        $.ajax({
            url: 'https://api.hsforms.com/submissions/v3/integration/submit/23750460/9093b969-0f7f-4017-a270-7460ede3c92a',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                fields: fields,
                context: {
                    hutk: document.cookie
                        .split('; ')
                        .find(row => row.startsWith('hubspotutk='))
                        ?.split('=')[1] || '',
                    pageUri: window.location.href,
                    pageName: document.title,
                    ipAddress: window.visitorIP
                }
            }),
            success: function (response) {

                console.log('HubSpot Success', response);

                $('#hcf-contact-form')[0].reset();

                $('.hcf-submit-btn').text('Message Sent ✓');

                // var $form = $('.onst-custom-form');

                // // Submit data into Shopify form
                // $form.css({
                //     'display': 'block',
                //     'visibility': 'hidden',
                //     'position': 'absolute',
                //     'left': '-9999px'
                // });

                // // Populate Shopify form from HubSpot fields
                // $form.find('input[name="Name"]').val(
                //     getField(fields, 'rr_first_name')
                // );

                // $form.find('input[name="contact[email]"]').val(
                //     getField(fields, 'email')
                // );

                // $form.find('input[name="Company"]').val(
                //     getField(fields, 'contact_company')
                // );

                // $form.find('input[name="Phone"]').val(
                //     getField(fields, 'phone')
                // );

                // $form.find('textarea[name="Comment"]').val(
                //     getField(fields, 'message')
                // );

                // // Submit Shopify form
                // $form.find('.onst-custom-form-submit').trigger('click');

                setTimeout(function() {
                    window.location.href = 'https://www.rapta.com.au/pages/thankyou';
                }, 500);
            },
            error: function (error) {

                console.error('HubSpot Error', error);

                $('.hcf-submit-btn')
                    .prop('disabled', false)
                    .text('Send Message');
            }
        });
    }

    /**
     * ----------------------------
     * VALIDATION
     * ----------------------------
     */

    function validateForm() {

        $('.hcf-error').remove();

        let valid = true;

        const name = $('#name').val().trim();
        const email = $('#email').val().trim();
        const phone = $('#phone').val().trim();
        const message = $('#message').val().trim();

        if (!name) {
            $('#name').after('<span class="hcf-error">Please enter your name</span>');
            valid = false;
        }

        if (!email) {

            $('#email').after('<span class="hcf-error">Please enter your email</span>');
            valid = false;

        } else {

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(email)) {
                $('#email').after('<span class="hcf-error">Please enter a valid email</span>');
                valid = false;
            }
        }

        if (!phone) {
            $('#phone').after('<span class="hcf-error">Please enter your phone number</span>');
            valid = false;
        }

        if (!message) {
            $('#message').after('<span class="hcf-error">Please enter your message</span>');
            valid = false;
        }

        return valid;
    }

    /**
     * ----------------------------
     * FORM SUBMIT
     * ----------------------------
     */

    $('#hcf-contact-form').on('submit', function (e) {
        e.preventDefault();

        if (!validateForm()) {
            return false;
        }

        submitToHubSpot();
    });

    /**
     * ----------------------------
     * REMOVE ERRORS
     * ----------------------------
     */

    $('#name, #email, #phone, #message').on(
        'keyup change',
        function () {
            $(this).next('.hcf-error').remove();
        }
    );

    /**
     * ----------------------------
     * INIT
     * ----------------------------
     */

    storeTrackingParams();

});

jQuery(document).on('click', '#cart-icon-bubble', function(e) {
    e.preventDefault();

    document.querySelector('.grfq-quote-widget-container')?.click();
    document.querySelector('.grfq-quote-widget')?.click();
    document.querySelector('.grfq-quote-widget-label')?.click();

    jQuery('.grfq__popupForm__modal_state')
        .prop('checked', true)
        .trigger('change');
});


jQuery(window).on('load', function() {
    setTimeout(function() {
        jQuery('.home-page .rfq-collection-btn').before('<hr class="rfq-divider">');
    }, 3000);

    setTimeout(function () {
        jQuery('.home-page .rfq-collection-btn').text('Quote on request');
    }, 3000);

    setTimeout(function() {
        jQuery('.equipment-section-custom .rfq-collection-btn').before('<hr class="rfq-divider">');
    }, 1000);

    setTimeout(function () {
        jQuery('.rfq-collection-btn').text('Quote on request');
    }, 1000);

    // $.ajax({
    //     type: 'POST',
    //     url: '/cart/clear.js',
    //     dataType: 'json',
    //     success: function() {
    //         console.log('Cart cleared');
    //         //location.reload(); // Optional
    //     }
    // });
    
});


jQuery(document).on('click', '.qty-plus', function () {
    const $input = jQuery(this).siblings('input[name="quantity"]');
    let qty = parseInt($input.val()) || 1;

    qty++;

    $input.val(qty)
          .attr('value', qty)
          .trigger('input')
          .trigger('change');
});

jQuery(document).on('click', '.qty-minus', function () {
    const $input = jQuery(this).siblings('input[name="quantity"]');
    let qty = parseInt($input.val()) || 1;
    const min = parseInt($input.attr('min')) || 1;

    if (qty > min) {
        qty--;

        $input.val(qty)
              .attr('value', qty)
              .trigger('input')
              .trigger('change');
    }
});


function getQuoteCount() {
    var count = jQuery('.grfq-quote-widget-container').data('number-of-items');
     if (count !== undefined) {
        $('.cart-count-bubble').show();
        $('.quote-count').remove();
        $('.cart-count-bubble').append('<span aria-hidden="true" class="quote-count">'+count+'</span>');
    }
}

jQuery(document).ready(function () {
    getQuoteCount();
});

jQuery(window).on('load', function() {
    setTimeout(function() {
        getQuoteCount();
    }, 1000);
});

jQuery(document).on('click', function () {
    getQuoteCount();
});